export enum BinCountType {
    ByBinCount = 0,
    ByBinSize = 1,
}
